import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID, // Replace with your client ID
        authority: 'https://login.microsoftonline.com/common',
        // redirectUri: 'https://jboofaeiajhcbcgfpklmoooedclfggim.chromiumapp.org./'
        redirectUri: "https://tar-achieving-pharmacies-margaret.trycloudflare.com/", // Replace with your redirect URI
        
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

// 👇 Add this — it's what your code imported
export const loginRequest = {
  scopes: ["openid", "profile", "User.Read", "email"], // permission scopes
  prompt: "select_account", // always ask user which account to use
};

export function useMicrosoftLogin() {
  const { instance, accounts } = useMsal();

  async function login() {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      console.log("Login success:", loginResponse);
      return loginResponse.account;
    } catch (err) {
      console.error("Login failed:", err);
      throw err;
    }
  }

  async function getAccessToken() {
    const activeAccount = accounts[0] || instance.getActiveAccount();
    if (!activeAccount) return null;

    try {
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      return tokenResponse.accessToken;
    } catch (err) {
      console.warn("Silent token failed, retrying popup:", err);
      const tokenResponse = await instance.acquireTokenPopup(loginRequest);
      return tokenResponse.accessToken;
    }
  }

  return { login, getAccessToken };
}


export async function getUserDetails(accessToken) {
  const res = await fetch("https://graph.microsoft.com/v1.0/me", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.json();
}
